import React from 'react';
import NavbarDropdown from './NavbarDropdown';
import {
  accueilNavBar,
  dpsNavBar,
  structureNavBar,
  recrutementNavBar,
} from 'routes/siteMaps';
import NavbarDropdownApp from './NavbarDropdownApp';
import HabilitationService from 'services/habilitationsService';

const NavbarTopDropDownMenus = () => {

  return (
    <>
      <NavbarDropdown title={accueilNavBar.label}>
        <NavbarDropdownApp items={accueilNavBar.children} />
      </NavbarDropdown>
      <NavbarDropdown title={dpsNavBar.label}>
        <NavbarDropdownApp items={dpsNavBar.children} />
      </NavbarDropdown>
      <NavbarDropdown title={recrutementNavBar.label}>
        <NavbarDropdownApp items={recrutementNavBar.children} />
      </NavbarDropdown>
      {HabilitationService.habilitations ?
        <NavbarDropdown title={structureNavBar.label}>
          <NavbarDropdownApp items={structureNavBar.children} />
        </NavbarDropdown>
      : null}
    </>
  );
};

export default NavbarTopDropDownMenus;
